import styled from "styled-components";

export const ProductContentWrapper = styled.div`
    margin-top: 5rem;
    padding-bottom: 1.25rem;
`;